import { render, staticRenderFns } from "./shippingType.vue?vue&type=template&id=79ecd714"
import script from "./shippingType.vue?vue&type=script&lang=js"
export * from "./shippingType.vue?vue&type=script&lang=js"
import style0 from "./shippingType.vue?vue&type=style&index=0&id=79ecd714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports